import { render, staticRenderFns } from "./partnerBoard.vue?vue&type=template&id=8e406700&scoped=true&lang=pug"
import script from "./partnerBoard.vue?vue&type=script&lang=js"
export * from "./partnerBoard.vue?vue&type=script&lang=js"
import style0 from "./partnerBoard.vue?vue&type=style&index=0&id=8e406700&prod&lang=css"
import style1 from "./partnerBoard.vue?vue&type=style&index=1&id=8e406700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e406700",
  null
  
)

export default component.exports